export default __webpack_public_path__ + "8a650c62291bd0884eae01866fb68249.svg";